import { apiRequest } from '../../lib/api';
import type { PaginatedResponse } from '../../types/domain';

export interface LocationOption { id: string; name: string; city: string; timezone: string; today: string }

export async function loadOptions<T>(url: string, accessToken: string, signal: AbortSignal): Promise<T[]> {
  const rows: T[] = [];
  let page = 1;
  while (true) {
    const result = await apiRequest<PaginatedResponse<T>>(`${url}&page_size=100&page=${page}`, { accessToken, signal });
    rows.push(...result.results);
    if (!result.next) return rows;
    page += 1;
  }
}

export function todayInPakistan() {
  const parts = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Asia/Karachi',
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}
